import {
  GET_SCHOLAR_DATA,
  GET_UNITS,
  DELETE_UNIT,
  SET_MERGE_ERROR,
  RESET_SCHOLARS_DATA,
  CREATE_SCHOLAR_ERROR,
  CREATE_ANETAPACK_ERROR,
  GET_UNIT_STATS,
  USER_LOGOUT,
} from 'actions/actionTypes';
import { IScholarsState, IScholars, UnitStats } from 'types';

type ActionType =
  | { type: 'GET_SCHOLAR_DATA'; payload: IScholars }
  | { type: 'GET_UNITS'; payload: IScholars[] }
  | { type: 'SET_MERGE_ERROR'; payload: string }
  | { type: 'CREATE_SCHOLAR_ERROR'; payload: string }
  | { type: 'CREATE_ANETAPACK_ERROR'; payload: string[] }
  | { type: 'DELETE_UNIT'; payload: number }
  | { type: 'USER_LOGOUT' }
  | { type: 'GET_UNIT_STATS'; payload: UnitStats }
  | { type: 'RESET_SCHOLARS_DATA' };

const initialState: IScholarsState = {
  scholar: null,
  units: null,
  stats: null,
  errors: '',
  anetapackError: [],
};

const scholars = (state = initialState, action: ActionType): IScholarsState => {
  switch (action.type) {
    case GET_SCHOLAR_DATA:
      return {
        ...state,
        scholar: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        units: null,
        scholar: null,
        stats: null,
      };
    case GET_UNITS:
      return {
        ...state,
        units: action.payload,
      };
    case GET_UNIT_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case SET_MERGE_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    case CREATE_SCHOLAR_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    case CREATE_ANETAPACK_ERROR:
      return {
        ...state,
        anetapackError: action.payload,
      };
    case DELETE_UNIT: {
      const { units } = state;
      const updatedList = units?.filter(
        (scholar) => scholar.id !== action.payload
      );
      return {
        ...state,
        units: updatedList || null,
      };
    }
    case RESET_SCHOLARS_DATA:
      return initialState;
    default:
      return state;
  }
};

export default scholars;
